import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/custom/button'
import { IconShieldLock } from '@tabler/icons-react'

export default function ForbiddenError() {
  const navigate = useNavigate()
  const { t } = useTranslation(['global'])

  return (
    <div className='h-svh'>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
        <div className='mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-red-500/10 dark:bg-red-500/20'>
          <IconShieldLock
            size={48}
            className='text-red-500 dark:text-red-400'
            stroke={1.5}
          />
        </div>
        <h1 className='text-[7rem] font-bold leading-tight'>403</h1>
        <span className='font-medium'>{t('errors.403.title')}</span>
        <p className='text-center text-muted-foreground'>
          {t('errors.403.description')}
        </p>
        <div className='mt-6 flex gap-4'>
          <Button variant='outline' onClick={() => navigate(-1)}>
            {t('errors.go_back')}
          </Button>
          <Button onClick={() => navigate('/')}>
            {t('errors.back_to_home')}
          </Button>
        </div>
      </div>
    </div>
  )
}
